import { render, staticRenderFns } from "./SbppsInstructorSpecificIcardPrint.vue?vue&type=template&id=726373b9&scoped=true&"
import script from "./SbppsInstructorSpecificIcardPrint.vue?vue&type=script&lang=js&"
export * from "./SbppsInstructorSpecificIcardPrint.vue?vue&type=script&lang=js&"
import style0 from "./SbppsInstructorSpecificIcardPrint.vue?vue&type=style&index=0&id=726373b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726373b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VRow,VSpacer})
